module.exports = __webpack_public_path__ + "static/media/2021_IMG_1768.b4a5dc40.jpg";